// Utility function to dynamically set favicon based on domain
export const setFaviconBasedOnDomain = () => {
    const hostname = window.location.hostname;
    let faviconPath;

    // Determine favicon based on domain
    if (hostname === "kips.jueducation.com") {
        faviconPath = "/KipsFavicon.png";
    } else if (hostname === "aspire.jueducation.com") {
        faviconPath = "/AspireFavicon.png";
    } else if (hostname === "localhost") {
        // Default to Aspire favicon for localhost
        faviconPath = "/AspireFavicon.png";
    } else if (hostname === "192.168.1.99") {
        // Default to Aspire favicon for local server
        faviconPath = "/AspireFavicon.png";
    } else {
        // Default fallback
        faviconPath = "/AspireFavicon.png";
    }

    // Find existing favicon link elements and update them
    const links = document.querySelectorAll("link[rel*='icon']");
    links.forEach(link => {
        link.href = faviconPath;
    });

    // If no favicon link exists, create one
    if (links.length === 0) {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = faviconPath;
        document.head.appendChild(link);
    }

    // Also update apple-touch-icon if it exists
    const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']");
    if (appleTouchIcon) {
        // Use the corresponding logo for apple-touch-icon
        const logoPath = hostname === "kips.jueducation.com" ? "/KipsLogo.png" : "/AspireLogo.png";
        appleTouchIcon.href = logoPath;
    }
};

// Function to get favicon path based on domain (for use in components)
export const getFaviconPath = () => {
    const hostname = window.location.hostname;

    if (hostname === "kips.jueducation.com") {
        return "/KipsFavicon.png";
    } else if (hostname === "aspire.jueducation.com") {
        return "/AspireFavicon.png";
    } else if (hostname === "localhost") {
        return "/AspireFavicon.png";
    } else if (hostname === "192.168.1.99") {
        return "/AspireFavicon.png";
    } else {
        return "/AspireFavicon.png";
    }
};

// Function to get logo path based on domain
export const getLogoPath = () => {
    const hostname = window.location.hostname;

    if (hostname === "kips.jueducation.com") {
        return "/KipsLogo.png";
    } else {
        return "/AspireLogo.png";
    }
};
